import { render, staticRenderFns } from "./Speaking2.vue?vue&type=template&id=5036f0c8&scoped=true"
import script from "./Speaking2.vue?vue&type=script&lang=js"
export * from "./Speaking2.vue?vue&type=script&lang=js"
import style0 from "./Speaking2.vue?vue&type=style&index=0&id=5036f0c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5036f0c8",
  null
  
)

export default component.exports